export default __webpack_public_path__ + "static/media/Aura-Egg__10.7999ca8e.png";